import React, { useState, useEffect, useCallback } from 'react';
import { obrasSocialesAPI } from '../../../core/api/api';
import { pagosFacturasAPI } from '../services/pagosFacturasAPI';
import { ToastContainer } from '../../../shared/components/Toast';
import { usePagosFacturasOS } from '../hooks/usePagosFacturasOS';
import FiltrosPagosFacturas from './FiltrosPagosFacturas';
import TablaFacturasOS from './TablaFacturasOS';
import TotalizadoresFacturas from './TotalizadoresFacturas';
import PaginadorFacturas from './PaginadorFacturas';
import ModalAdjuntarConstancia from './ModalAdjuntarConstancia';
import VisorConstancia from './VisorConstancia';

const GrillaPagosFacturasOS = () => {
  const {
    facturas,
    totalFacturas,
    montoTotal,
    page,
    totalPages,
    loading,
    error,
    filtros,
    buscarFacturas,
    cambiarFiltros,
    cambiarPagina,
    marcarPagada,
  } = usePagosFacturasOS();

  // Catálogos
  const [entidades, setEntidades] = useState([]);
  const [obrasSociales, setObrasSociales] = useState([]);

  // Modal states
  const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
  const [mostrarModalAdjuntar, setMostrarModalAdjuntar] = useState(false);
  const [mostrarVisor, setMostrarVisor] = useState(false);

  // Toast
  const [toast, setToast] = useState(null);

  // Cargar catálogos al montar
  useEffect(() => {
    const cargarCatalogos = async () => {
      try {
        const [entidadesRes, obrasSocialesRes] = await Promise.all([
          pagosFacturasAPI.getEntidadesFacturacion(),
          obrasSocialesAPI.getObrasSociales(),
        ]);
        setEntidades(entidadesRes || []);
        const osData = obrasSocialesRes.data || obrasSocialesRes || [];
        setObrasSociales(
          osData.map((os) => ({ id: os.idObraSocial, nombre: os.obraSocial }))
        );
      } catch {
        // Silently fail on catalogue load - filters will show empty
      }
    };

    cargarCatalogos();
  }, []);

  // Mostrar toast de error cuando el hook reporta un error
  useEffect(() => {
    if (error) {
      setToast({ message: error, type: 'error' });
    }
  }, [error]);

  // Handlers de modal adjuntar
  const handleAdjuntar = useCallback((factura) => {
    setFacturaSeleccionada(factura);
    setMostrarModalAdjuntar(true);
  }, []);

  const handleCerrarModalAdjuntar = useCallback(() => {
    setMostrarModalAdjuntar(false);
    setFacturaSeleccionada(null);
  }, []);

  const handleAdjuntarSuccess = useCallback(async (facturaId, monto) => {
    const resultado = await marcarPagada(facturaId, monto);

    if (resultado.success) {
      setToast({ message: 'Constancia adjuntada correctamente. La factura fue marcada como ABONADA.', type: 'success' });
    } else {
      setToast({ message: 'No se pudo completar la operación. Intente nuevamente.', type: 'error' });
    }
  }, [marcarPagada]);

  // Handlers de visor constancia
  const handleVerConstancia = useCallback((factura) => {
    setFacturaSeleccionada(factura);
    setMostrarVisor(true);
  }, []);

  const handleCerrarVisor = useCallback(() => {
    setMostrarVisor(false);
    setFacturaSeleccionada(null);
  }, []);

  // Handler de búsqueda
  const handleBuscar = useCallback(() => {
    buscarFacturas();
  }, [buscarFacturas]);

  return (
    <div className="grilla-pagos-facturas-os">
      <FiltrosPagosFacturas
        filtros={filtros}
        onCambiarFiltros={cambiarFiltros}
        onBuscar={handleBuscar}
        entidades={entidades}
        obrasSociales={obrasSociales}
      />

      <TotalizadoresFacturas
        totalFacturas={totalFacturas}
        montoTotal={montoTotal}
      />

      <TablaFacturasOS
        facturas={facturas}
        onAdjuntar={handleAdjuntar}
        onVerConstancia={handleVerConstancia}
        loading={loading}
      />

      <PaginadorFacturas
        page={page}
        totalPages={totalPages}
        onCambiarPagina={cambiarPagina}
      />

      <ModalAdjuntarConstancia
        isOpen={mostrarModalAdjuntar}
        onClose={handleCerrarModalAdjuntar}
        factura={facturaSeleccionada}
        onSuccess={handleAdjuntarSuccess}
      />

      <VisorConstancia
        isOpen={mostrarVisor}
        onClose={handleCerrarVisor}
        factura={facturaSeleccionada}
      />

      <ToastContainer toast={toast} onClose={() => setToast(null)} />
    </div>
  );
};

export default GrillaPagosFacturasOS;
